import { render, staticRenderFns } from "./ResidualValuesVersionDetail.vue?vue&type=template&id=51023350&scoped=true"
import script from "./ResidualValuesVersionDetail.vue?vue&type=script&lang=js"
export * from "./ResidualValuesVersionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51023350",
  null
  
)

export default component.exports